/** localStorage: last acknowledged pending received request count per portal user */
export function pendingRequestsReceivedBaselineKey(userId: string) {
  return `gt.pendingRequests.received.${userId}`;
}
